import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress, configure_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import Icon from "semantic-ui-react/dist/es/elements/Icon";

const ListeningOverview = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                listening_overview: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    }, []);

    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        <Icon name="assistive listening systems icon" size="large" className="icon_content" color="#268af6" width="20px" height="20px" />
                        <span className="content_title">Listening Overview</span>
                    </div>
                    <div className="text_content">
                        <p>{`Social listening is process of analyzing conversations and trends across the internet including large global social networks, regional social networks, review sites and millions of blogs and forums.`}</p>
                        <p>
                            This does not just include posts or comments around your brand, but also your competitors and the industry as a whole, giving you
                            rich actionable insights.
                        </p>
                        <p>You can use social listening to accomplish some of the following</p>
                        <p>1. Monitor your brand / products</p>
                        <p>2. Perform competitive benchmarking</p>
                        <p>3. Track and improve customer engagement</p>
                        <p>4. Discover new sales opportunities</p>
                        <p>5. Manage crises better</p>
                        <p>6. Identify influencers, advocates and detractors for your brand</p>
                        <p>7. Set up dashboards, reports and alerts </p>
                    </div>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/7UaewQomAZY"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default ListeningOverview;
